// extracted by mini-css-extract-plugin
export default {"confirmation-popup__content":"ConfirmationPopup_confirmation-popup__content__zKCvV"};